// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  position: relative;
}

.wrap {
  width: 100%;
  height: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.value {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: var(--black);
  flex-grow: 1;
}
.value.placeholder {
  color: var(--grey-text);
}

.icon-arrow {
  font-size: 1.8rem;
  color: var(--dark);
  margin-left: 0.8rem;
}

.dropdown {
  max-height: 30.2rem;
  background: var(--white);
  border-radius: 0.8rem;
  box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 5.1rem;
  right: 0;
  left: 0;
  gap: 1rem;
  z-index: 1;
  overflow: auto;
}

.option {
  min-height: 4.2rem;
  font-size: 1.4rem;
  line-height: 1.7rem;
  color: var(--black);
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.option input {
  display: none;
}
.option i {
  font-size: 1.8rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/multiselect/multiselect.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AACF;AACE;EACE,uBAAA;AACJ;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;AAAF;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,iBAAA;AADJ","sourcesContent":[":host {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.wrap {\n  width: 100%;\n  height: 100%;\n  padding: 0 1rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.value {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n  color: var(--black);\n  flex-grow: 1;\n\n  &.placeholder {\n    color: var(--grey-text);\n  }\n}\n\n.icon-arrow {\n  font-size: 1.8rem;\n  color: var(--dark);\n  margin-left: 0.8rem;\n}\n\n.dropdown {\n  max-height: 30.2rem;\n  background: var(--white);\n  border-radius: 0.8rem;\n  box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1);\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 5.1rem;\n  right: 0;\n  left: 0;\n  gap: 1rem;\n  z-index: 1;\n  overflow: auto;\n}\n\n.option {\n  min-height: 4.2rem;\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  color: var(--black);\n  padding: 0 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  & input {\n    display: none;\n  }\n\n  & i {\n    font-size: 1.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
